import { ReactElement } from 'react'
import { useHeader } from './hooks'
import HeaderTemplate from './template'

const HeaderPage = (): ReactElement => {
    const { languages, numberOfReviews } = useHeader()

    return (
        <HeaderTemplate
            languages={languages}
            numberOfReviews={numberOfReviews}
        />
    )
}

export default HeaderPage
